module.exports = "/packs/images/pages/venues/play_tablet~b2b072b64b9cee2e821c94fd5454bf2f.jpg";